import modalBox from '@/components/form-modal/modal-tools';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import ls from '@/utils/local-storage';
import { reactive } from 'vue';
import { message } from 'ant-design-vue';
import { create_customer } from '@/api/mjstore-model';
import pinyin from 'pinyin';

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
export const btn_obj = {
  cb: () => {
    const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店
    const editModal = reactive({
      visible: true,
      loading: false,
      title: '新增顾客',
      form: {
        settings: {
          labelAlign: 'right',
          layout: 'horizontal',
          col: [],
        },
        fields: [
          {
            type: 'input',
            name: 'name',
            label: '会员姓名',
            disabled: false,
            allowClear: true,
            inputType: 'text',
            defaultValue: '',
            placeholder: '请填写会员姓名',
          },
          {
            type: 'input',
            name: 'pinyin',
            label: '拼音',
            disabled: false,
            allowClear: true,
            inputType: 'text',
            defaultValue: '',
            placeholder: '请填写拼音',
          },
          {
            type: 'datepicker',
            name: 'join_date',
            label: '建档日期',
            disabled: false,
            allowClear: true,
            inputType: 'number',
            defaultValue: '',
            showTime: false,
            placeholder: '请填写建档日期',
          },
          {
            type: 'radio',
            name: 'gender',
            label: '性别',
            disabled: false,
            allowClear: true,
            labelKey: 'name',
            valueKey: 'value',
            defaultValue: '',
            placeholder: '请选择性别',
          },
          {
            type: 'datepicker',
            name: 'birthday',
            label: '出生日期',
            disabled: false,
            allowClear: true,
            inputType: 'number',
            defaultValue: '',
            showTime: false,
            placeholder: '请填写出生日期',
          },
          {
            type: 'input',
            name: 'phone',
            label: '手机',
            disabled: false,
            allowClear: true,
            inputType: 'text',
            defaultValue: '',
            placeholder: '请填写手机',
          },
          {
            type: 'remoteselect',
            name: 'shop_id',
            label: '会籍',
            disabled: !!current_shop,
            placeholder: '请选择会籍',
            datasourceType: 'remote',
            mode: 'default',
            allowClear: true,
            modalType: 'mjstore-shop',
          },
          {
            type: 'remoteselect',
            name: 'hk_type_id',
            label: '获客方式',
            disabled: false,
            placeholder: '请选择获客方式',
            datasourceType: 'remote',
            mode: 'default',
            allowClear: true,
            modalType: 'mjstore-hktype',
          },
          {
            type: 'remoteselect',
            name: 'adviser_id',
            label: '所属顾问',
            disabled: false,
            placeholder: '请选择所属顾问',
            datasourceType: 'remote',
            mode: 'default',
            allowClear: true,
            modalType: 'mjstore-staff',
          },
        ],
        rules: {
          name: [{ required: true, message: '请填输入会员姓名' }],
          join_date: [{ required: true, message: '请填输入建档日期' }],
          birthday: [{ required: true, message: '请填输入出生日期' }],
          phone: [{ required: true, pattern: /^1[3456789]\d{9}$/, message: '请填输入正确手机' }],
          shop_id: [{ required: true, message: '请填输入会籍' }],
          hk_type_id: [{ required: true, message: '请选择获客方式' }],
          adviser_id: [{ required: true, message: '请选择所属顾问' }],
          pinyin: [{ required: true, message: '请输入拼音' }],
        },
        model: reactive({
          org_id: current_org?.id,
          is_active: true,
          name: null,
          join_date: null,
          gender: null,
          birthday: null,
          phone: null,
          adviser_id: null,
          shop_id: current_shop?.id,
          hk_type_id: null,
          pinyin: null,
        }),
        watch:{
          name:(data:any)=>{
            const list = pinyin(data.name, {
              style: 4,
            });
            let str = '';
            list.forEach(item => {
              str += item;
            });
            data['pinyin'] = str;
          },
        },
      },
      options: {
        gender: [
          { value: 0, name: '女' },
          { value: 1, name: '男' },
        ],
      },
      ok: (payload: any) => {
        editModal.loading = true;
        create_customer(payload)
          .then(() => {
            message.success('新增顾客成功');
          })
          .finally(() => {
            editModal.loading = false;
          });
      },
    });
    modalBox(editModal);
  },
};
// export const btn_appointment =
// {
//   cb: () => {
//     const editModal = reactive({
//       visible: true,
//       title: '新增预约',
//       form: {
//         settings: {
//           labelAlign: 'right',
//           layout: 'horizontal',
//           col: [],
//         },
//         fields: [
//           {
//             type: 'remotemodal',
//             name: 'customer_id',
//             label: '客户',
//             disabled: false,
//             placeholder: '请选择客户',
//             datasourceType: 'remote',
//             mode: 'default',
//             allowClear: true,
//             modalType: 'mjstore-customer',
//           },
//           {
//             type: 'remotemodal',
//             name: 'project_id',
//             label: '项目名称',
//             disabled: false,
//             placeholder: '请选择项目名称',
//             datasourceType: 'remote',
//             mode: 'default',
//             allowClear: true,
//             modalType: 'mjstore-project',
//           },
//           {
//             type: 'input',
//             name: 'note',
//             label: '预约号',
//             disabled: false,
//             allowClear: true,
//             inputType: 'text',
//             defaultValue: '',
//             placeholder: '请填写预约号',
//           },
//           {
//             type: 'datepicker',
//             name: 'start_datetime',
//             label: '开始时间',
//             disabled: false,
//             allowClear: true,
//             inputType: 'number',
//             defaultValue: '',
//             showTime: true,
//             format: 'YYYY-MM-DD HH:mm',
//             valueFormat: 'YYYY-MM-DD HH:mm',
//             placeholder: '请填写开始时间',
//           },
//           {
//             type: 'datepicker',
//             name: 'end_datetime',
//             label: '结束时间',
//             disabled: false,
//             allowClear: true,
//             inputType: 'number',
//             defaultValue: '',
//             showTime: true,
//             format: 'YYYY-MM-DD HH:mm',
//             valueFormat: 'YYYY-MM-DD HH:mm',
//             placeholder: '请填写结束时间',
//           },
//           {
//             type: 'remotemodal',
//             name: 'shop_id',
//             label: '预约门店',
//             disabled: false,
//             placeholder: '请选择预约门店',
//             datasourceType: 'remote',
//             mode: 'default',
//             allowClear: true,
//             modalType: 'mjstore-shop',
//           },
//           {
//             type: 'remotemodal',
//             name: 'staff_id',
//             label: '预约治疗师',
//             disabled: false,
//             placeholder: '请选择预约治疗师',
//             datasourceType: 'remote',
//             mode: 'default',
//             allowClear: true,
//             modalType: 'mjstore-staff',
//           },
//         ],
//         rules: {
//           customer_id: [{ required: true, message: '请填预约客户' }],
//           project_id: [{ required: true, message: '请填预约客项目' }],
//           shop_id: [{ required: true, message: '请填预约门店' }],
//           staff_id: [{ required: true, message: '请填预约治疗师' }],
//         },
//         model: reactive({
//           org_id: current_org?.id,
//           is_active: true,
//           customer_id: null,
//           project_id: null,
//           note: null,
//           start_datetime: null,
//           end_datetime: null,
//           shop_id: null,
//           staff_id: null,
//         }),
//       },
//       options: {},
//       ok: (payload: any) => {
//         create_appointment(payload).then(() => {
//           message.success('新增预约成功');
//         });
//       },
//     });
//     modalBox(editModal);
//   },
// };
